const getModule = {
  state: {
    selected: false,
    url: '',
    type: '',
  },
  mutations: {
    setKaratayRuhsatsiz(state, data) {
      if (state.type == data.type) {
        state.selected = false
        state.url = ''
        state.type = ''
      } else {
        state.selected = true
        state.url = data.url
        state.type = data.type
      }
    },
  },
  actions: {
    setKaratayRuhsatsiz({ commit }, data) {
      commit('setKaratayRuhsatsiz', data)
    },
  },
  getters: {},
}

export default getModule
